module.exports = __webpack_public_path__ + "img/House-Cat.204ed002.png";